module.exports = ".hand {\r\n    border: 2px solid black;\r\n}\r\n\r\nimg {\r\n    width: 65px;\r\n    height: 90px;\r\n} "


//////////////////
// WEBPACK FOOTER
// ./src/app/blackjack/blackjack.component.css
// module id = ./src/app/blackjack/blackjack.component.css
// module chunks = main